module.exports = __webpack_public_path__ + "img/search.98c42f30.svg";